import { useEffect, useState } from 'react';

const read = (): TelegramWebAppUser | null =>
  window.Telegram?.WebApp?.initDataUnsafe?.user ?? null;

/** The current Telegram user (from initDataUnsafe). Polls briefly in case the
 *  WebApp object isn't ready on first render. Returns null outside Telegram. */
export function useTelegramUser(): TelegramWebAppUser | null {
  const [user, setUser] = useState<TelegramWebAppUser | null>(read);

  useEffect(() => {
    if (user) return;
    let tries = 0;
    const id = window.setInterval(() => {
      const u = read();
      if (u) {
        setUser(u);
        window.clearInterval(id);
      } else if (++tries > 50) {
        window.clearInterval(id);
      }
    }, 100);
    return () => window.clearInterval(id);
  }, [user]);

  return user;
}

/** "First Last", falling back to @username, then a generic label. */
export function telegramName(u: TelegramWebAppUser | null, fallback = 'User'): string {
  if (!u) return fallback;
  const full = [u.first_name, u.last_name].filter(Boolean).join(' ').trim();
  return full || u.username || fallback;
}
